export const ANIMATION_TIMING = ['ease', 'linear', 'ease-in', 'ease-out'];
export const ANIMATION_DURATION = [20, 23, 27, 29];
